import { LocalStyles } from "@paperbits/common/styles";

export class ProfileModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
